export function sectionUrl(url, sectionId) {
  const separator = url.includes('?') ? (url.endsWith('?') || url.endsWith('&') ? '' : '&') : '?';
  return `${url}${separator}section_id=${encodeURIComponent(sectionId)}`;
}

function navigate(href) {
  window.location.href = href;
}

function responseDocument(html) {
  return new DOMParser().parseFromString(html, 'text/html');
}

function isFacetUrl(href) {
  const query = href.split('?')[1]?.split('#')[0] ?? '';
  const params = new URLSearchParams(query);
  return [...params.keys()].some((key) => key.startsWith('filter.') || key === 'sort_by');
}

async function fetchSection(href, sectionId) {
  const response = await fetch(sectionUrl(href, sectionId));
  if (!response.ok) throw new Error('section fetch failed');
  return responseDocument(await response.text());
}

async function loadMore(link, root, more) {
  try {
    const documentFragment = await fetchSection(link.getAttribute('href'), root.getAttribute('data-section-id'));
    const responseGrid = documentFragment.querySelector('.vlx-facet__grid');
    const grid = root.querySelector('.vlx-facet__grid');
    for (const child of [...responseGrid.children]) grid.appendChild(child);

    const responseMore = documentFragment.querySelector('[data-facet-more]');
    if (responseMore) more.replaceWith(responseMore);
    else more.remove();
  } catch {
    navigate(link.getAttribute('href'));
  }
}

async function replaceFacets(link, root) {
  const href = link.getAttribute('href');
  try {
    const documentFragment = await fetchSection(href, root.getAttribute('data-section-id'));
    const replacement = documentFragment.querySelector('[data-facet-root]');
    root.replaceWith(replacement);
    window.history.pushState({}, '', href);
  } catch {
    navigate(href);
  }
}

document.addEventListener('click', (event) => {
  const target = event.target;
  const more = target.closest?.('[data-facet-more]');
  if (more) {
    const link = target.closest('a') ?? more.querySelector('a');
    const root = more.closest('[data-facet-root]');
    if (link && root) {
      event.preventDefault();
      loadMore(link, root, more);
    }
    return;
  }

  const root = target.closest?.('[data-facet-root]');
  const link = target.closest?.('a');
  if (!root || !link || !isFacetUrl(link.getAttribute('href'))) return;

  event.preventDefault();
  replaceFacets(link, root);
});
